// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"e9ded142","404":"23bcb1f1"}[chunkId] + ".chunk.js";
};